export default __webpack_public_path__ + "static/media/BoldIcon.3c41fb7c.svg";